export default function route() {
    return { match: true, precedence: -10 };
}
